<template>
  <v-row>
    <v-col>
      <v-row>
        <v-col>
          <v-autocomplete
            label="Tempo de Expiração de Login"
            v-model="sessionExpirationTimeValue"
            outlined
            dense
            hide-details
            background-color="white"
            :items="expirationValues"
            item-text="name"
            item-value="value"
            :loading="isLoading"
          />
        </v-col>
        <v-col>
          <v-autocomplete
            label="Notificação de Expiração de Login"
            v-model="notificationTimeValue"
            outlined
            dense
            hide-details
            background-color="white"
            :items="expirationNotificationValues"
            item-text="name"
            item-value="value"
            :loading="isLoading"
          />
        </v-col>
        <v-col cols="2">
          <v-btn
            color="light-blue"
            block
            dark
            :disabled="isLoading"
            @click="save"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import GET_SYSTEM_SETTING from "@/graphql/system_settings/system_setting.gql";
import SAVE_SYSTEM_SETTING from "@/graphql/system_settings/save_system_setting.gql";

import { EXPIRATION_VALUES } from "@/components/config/user/session_expiration_time_form/expiration_values.js";
import { EXPIRATION_NOTIFICATION_VALUES } from "@/components/config/user/session_expiration_time_form/expiration_notification_values.js";

export default {
  name: "ConfigUserSessionExpirationForm",
  data() {
    return {
      sessionExpirationTimeValue: null,
      notificationTimeValue: null,
      expirationValues: EXPIRATION_VALUES,
      expirationNotificationValues: EXPIRATION_NOTIFICATION_VALUES,
    };
  },
  apollo: {
    sessionExpirationTimeSetting: {
      query: GET_SYSTEM_SETTING,
      variables: {
        name: "session_expiration_time",
      },
      fetchPolicy: "no-cache",
      update({ systemSetting }) {
        this.sessionExpirationTimeValue = Number(systemSetting.value);
        return systemSetting;
      },
    },
    notificationTimeSetting: {
      query: GET_SYSTEM_SETTING,
      variables: {
        name: "session_expiration_notification_time",
      },
      fetchPolicy: "no-cache",
      update({ systemSetting }) {
        this.notificationTimeValue = Number(systemSetting.value);
        return systemSetting;
      },
    },
  },
  computed: {
    isLoading() {
      if (!this.sessionExpirationTimeSetting) return true;
      if (!this.notificationTimeSetting) return true;

      const {
        notificationTimeSetting,
        sessionExpirationTimeSetting,
      } = this.$apollo.queries;

      return (
        notificationTimeSetting.loading || sessionExpirationTimeSetting.loading
      );
    },
  },
  methods: {
    async save() {
      await this.saveSetting(
        "session_expiration_time",
        "sessionExpirationTimeValue"
      );
      await this.saveSetting(
        "session_expiration_notification_time",
        "notificationTimeValue"
      );

      this.notifySaveSuccess();
    },
    async saveSetting(name, key) {
      const { data } = await this.apolloMutate({
        mutation: SAVE_SYSTEM_SETTING,
        variables: {
          name,
          value: String(this[key]),
        },
      });

      this[key] = Number(data.saveSystemSetting.value);
    },
    notifySaveSuccess() {
      const message =
        "Tempo de expiração de login salvo! " +
        "As alterações farão efeito no próximo login de cada usuário.";

      this.$store.dispatch("createNotification", {
        message,
        type: "success",
      });
    },
  },
};
</script>

<style scoped></style>
